import type { Icon } from '@onefootprint/icons';
import { IcoCode16, IcoCsv16, IcoFileText16, IcoImages16, IcoMarkdown16, IcoPdf16 } from '@onefootprint/icons';
import type { ArtifactMimeType } from '@onefootprint/request-types/dashboard';

const getArtifactIcon = (mimeType: ArtifactMimeType): Icon => {
  switch (mimeType) {
    case 'text/markdown':
      return IcoMarkdown16;
    case 'application/pdf':
      return IcoPdf16;
    case 'application/json':
      return IcoCode16;
    case 'text/csv':
      return IcoCsv16;
    case 'text/plain':
      return IcoFileText16;
    case 'image/png':
    case 'image/jpeg':
      return IcoImages16;
    default:
      return IcoFileText16;
  }
};

export default getArtifactIcon;
